export enum NotesQueryKey {
    NotesByAssets = "notes-by-assets"
}
